import type { ReactNode } from 'react';
import { Button, Text } from '@belong/ui';
import { clsx } from 'clsx';
import { FAILED_PAYMENTS_STRINGS } from './failed-payments-strings';

type ResolveModalFooterProps = {
  onSubmit: () => void;
  submitLabel?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  wideSubmit?: boolean;
  pinnedSubmitWidth?: boolean;
};

export function ResolveModalFooter({
  onSubmit,
  submitLabel = FAILED_PAYMENTS_STRINGS['modal.footer.cta'],
  disabled = false,
  loading = false,
  wideSubmit = false,
  pinnedSubmitWidth = false,
}: ResolveModalFooterProps) {
  return (
    // Mobile: stacked full-width button with centered help text below.
    // Desktop (sm+): the original sticky footer bar (help text left, button right).
    <div className="flex flex-col items-center gap-md sm:-mx-xl sm:min-h-[107px] sm:flex-row-reverse sm:justify-between sm:gap-0 sm:rounded-b sm:border-0 sm:border-t sm:border-solid sm:border-gray sm:bg-light-gray sm:p-md">
      <Button
        size={
          wideSubmit || pinnedSubmitWidth
            ? { _: 'fluid', sm: 'auto' }
            : { _: 'fluid', sm: 'default' }
        }
        className={clsx(
          'whitespace-nowrap',
          wideSubmit &&
            !pinnedSubmitWidth &&
            'sm:!h-button sm:!min-w-[184px] sm:!px-lg',
          pinnedSubmitWidth && 'sm:!h-button sm:!min-w-[232px] sm:!px-lg',
        )}
        onClick={onSubmit}
        disabled={disabled || loading}
      >
        {submitLabel}
      </Button>
      <Text variant="body" className="text-center text-navy sm:text-left">
        {FAILED_PAYMENTS_STRINGS['modal.footer.help_prefix']}{' '}
        <span className="font-semibold uppercase">
          {FAILED_PAYMENTS_STRINGS['modal.footer.help_cta']}
        </span>
      </Text>
    </div>
  );
}
